import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import MobileStepper from "@material-ui/core/MobileStepper";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import lalit from "../../Images/slider1.jpg";
import louis_reed from "../../Images/slider2.jpg";
// import simon_kadula from "../../Images/simon-kadula.jpg";
import slider3 from '../../Images/slider3.jpg'
import slider4 from '../../Images/slider4.jpg'
import { Box } from "@material-ui/core";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const tutorialSteps = [
  {
    label: "Slider1",
    imgPath: lalit,
  },
  
  {
    label: 'Slider3',
    imgPath:
      slider3,
  },
  {
    label: 'Slider4',
    imgPath:
      slider4,
  },
 
  // {
  //   label: 'NeONBRAND Digital Marketing, Las Vegas, United States',
  //   imgPath:
  //     'https://images.unsplash.com/photo-1518732714860-b62714ce0c59?auto=format&fit=crop&w=400&h=250&q=60',
  // },
  // {
  //   label: 'Goč, Serbia',
  //   imgPath:
  //     'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
  // },
];

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "75px",
    maxWidth: "100%",
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginTop: "105px",
    },
  },

  img: {
    objectFit: "contain",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
    overflow: "hidden",
    width: "100%",
    height: "320px !important",
    // height: '100%',
    [theme.breakpoints.up("sm")]: {
      height: "500px !important",
    },
    [theme.breakpoints.up("md")]: {
      objectFit: 'cover',
    },
  },
  stepper: {
    transform: "rotate(90deg)",
    width: "70px",
    right: "0%",
    position: "absolute",
    top: "30%",
   
    background: "none",
    [theme.breakpoints.up("sm")]: {
      top: "50%",
    },
  },
  divider: {
    // Theme Color, or use css color in quote
    marginTop: "30px",
    background: "#000",
    height: "4px",
    marginLeft: "10px",
    marginRight: "10px",
  },
}));

function SwipeableTextMobileStepper() {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = tutorialSteps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <>
      <div className={classes.root}>
        <AutoPlaySwipeableViews
          axis={theme.direction === "rtl" ? "y-reverse" : "y"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
          animateHeight={true}
        >
          {tutorialSteps.map((step, index) => (
            <div key={step.label}>
              {Math.abs(activeStep - index) <= 3 ? (
                <Box style={{ backgroundColor: "#fff" }}>
                  <img
                    className={classes.img}
                    src={step.imgPath}
                    alt={step.label}
                  />
                </Box>
              ) : null}
            </div>
          ))}
        </AutoPlaySwipeableViews>
        <MobileStepper
          className={classes.stepper}
          steps={maxSteps}
          position="static"
          variant="dots"
          activeStep={activeStep}
        // nextButton={
        //   <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
        //     Next
        //     {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        //   </Button>
        // }
        // backButton={
        //   <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
        //     {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        //     Back
        //   </Button>
        // }
        />
      </div>
      {/* <Divider classes={{root: classes.divider}} /> */}
    </>
  );
}

export default SwipeableTextMobileStepper;
